/***
 *
 *   CATEGORY EMAIL TAB (stub)
 *   Token-pass empty state until email templates ship. Routes stay under
 *   /app/tickets/category/:id/email.
 *
 **********/

import React from 'react';
import { EmptyState } from 'components/lib';
import { useTranslate } from 'app/translations';

const TicketsCategoryEmail = () => {
    const { _t } = useTranslate();

    return (
        <EmptyState
            title={_t('ticket.category.email')}
            text={_t('ticket.category.comingSoon')}
            icon="mail"
        />
    );
};

export default TicketsCategoryEmail;
